var _path, _path2, _circle;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgValuesIcon3(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 100,
    height: 148,
    viewBox: "33 9 100 148",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M83.0006 58.376C96.596 58.376 107.618 47.3515 107.618 33.752C107.618 20.1524 96.5981 9.12793 83.0006 9.12793C69.4031 9.12793 58.3828 20.1524 58.3828 33.752C58.3828 47.3515 69.4052 58.376 83.0006 58.376Z",
    fill: "#C97F42"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M132.233 107.259C132.038 80.2299 110.076 58.376 82.9996 58.376C55.8047 58.376 33.7578 80.4229 33.7578 107.618H82.9996V107.624H33.7578V132.244C33.7578 145.841 44.7802 156.866 58.3777 156.866C71.9752 156.866 82.9374 145.902 82.9976 132.356C82.9976 132.393 82.9976 132.431 82.9976 132.466V156.872H132.239V107.261H132.231L132.233 107.259Z",
    fill: "#EAB1FC"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 58,
    cy: 132,
    r: 25,
    fill: "#FF794E"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgValuesIcon3);
export default __webpack_public_path__ + "static/media/values_icon3.7601c9f563bfd75590e9af3349975fe5.svg";
export { ForwardRef as ReactComponent };